export const transferTypes = {
  create: {
    text: 'transfer',
  },
  cancel: {
    text: 'cancel',
  },
};
